import searchEn from './en/en.json'
import searchAr from './ar/ar.json'
import searchEs from './es/es.json'
import searchDe from './de/de.json'
import searchIt from './it/it.json'
import searchFr from './fr/fr.json'
import searchPt from './pt/pt.json'
import searchEl from './el/el.json'
import searchBn from './bn/bn.json'
import searchSr from './sr/sr.json'
import searchCs from './cs/cs.json'
import searchPl from './pl/pl.json'
import searchHu from './hu/hu.json'
import searchSk from './sk/sk.json'
import searchRo from './ro/ro.json'
import searchBg from './bg/bg.json'
import searchMk from './mk/mk.json'
import searchSq from './sq/sq.json'

const SearchMessages = {
  en: { search: { ...searchEn } },
  ar: { search: { ...searchAr } },
  es: { search: { ...searchEs } },
  de: { search: { ...searchDe } },
  it: { search: { ...searchIt } },
  fr: { search: { ...searchFr } },
  pt: { search: { ...searchPt } },
  el: { search: { ...searchEl } },
  bn: { search: { ...searchBn } },
  sr: { search: { ...searchSr } },
  cs: { search: { ...searchCs } },
  pl: { search: { ...searchPl } },
  hu: { search: { ...searchHu } },
  sk: { search: { ...searchSk } },
  ro: { search: { ...searchRo } },
  bg: { search: { ...searchBg } },
  mk: { search: { ...searchMk } },
  sq: { search: { ...searchSq } },
}

export default SearchMessages
